import styled from 'styled-components';

import { PeopleInAssetsColors } from './colors';

// Section components
const PeopleSection = styled.div`
  margin-top: 10px;
`;

const SectionHeader = styled.div`
  margin-bottom: 10px;
  display: flex;
  align-items: center;
`;

const HeaderText = styled.p`
  color: ${PeopleInAssetsColors.DarkText};
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: -0.175px;
  margin-right: 5px;
`;

const HeaderIcon = styled.span`
  color: ${PeopleInAssetsColors.MediumText};
  font-size: 14px;
  cursor: pointer;
`;

// Content components
const PeopleContent = styled.div`
  border-radius: 4px;
  border: 1px solid ${PeopleInAssetsColors.LightBorder};
  background: ${PeopleInAssetsColors.White};
  display: flex;
  width: 100%;
  padding: 16px;
  align-items: center;
`;

const PeopleTagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
`;

// Person tag components
const PersonTag = styled.div`
  display: flex;
  align-items: center;
`;

const PersonImage = styled.div`
  width: 48px;
  height: 48px;
  margin-right: 10px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 4px;
  }
`;

const PersonName = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${PeopleInAssetsColors.White};
  border: 1px solid ${PeopleInAssetsColors.LightBorder};
  border-radius: 4px;
  padding: 0 12px;
  min-width: 150px;
  width: 200px;
  position: relative;
  height: 48px;

  .tooltip-component {
    flex: 1 1 0;
    min-width: 0;
    display: flex;

    > span {
      flex: 1 1 0;
      min-width: 0;
      display: flex;
    }
  }
`;

const PersonNameText = styled.p`
  font-size: 14px;
  margin: 0;
  cursor: pointer;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }
`;

const RemovePersonButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  margin-left: 8px;
  padding: 0px;

  .icon {
    font-size: 11px;
    color: ${PeopleInAssetsColors.MediumText};
  }

  &:hover .icon {
    color: ${PeopleInAssetsColors.DarkText};
  }
`;

// Dropdown components
const CustomDropdown = styled.div`
  width: 100%;

  .suggested-identity-names-list {
    left: 0;
    min-width: 200px;
    margin-top: 10px;
    max-height: 240px;
    overflow-y: auto;

    .autocomplete-option-image {
      border-radius: 4px;
    }
  }
`;

const DropdownHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  width: 100%;
`;

const SelectedOption = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  width: 100%;
`;

const OptionImage = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 8px;
  object-fit: cover;
`;

const OptionText = styled.span`
  font-size: 14px;
  color: ${PeopleInAssetsColors.DarkText};
`;

const Placeholder = styled.span`
  font-size: 14px;
  color: ${PeopleInAssetsColors.MediumText};
`;

const DropdownIcon = styled.span`
  display: flex;
  align-items: center;
  height: 100%;
  cursor: pointer;
  .icon {
    font-size: 12px;
    color: ${PeopleInAssetsColors.MediumText};
  }

  &:hover .icon {
    color: ${PeopleInAssetsColors.DarkText};
  }
`;

const DropdownOptions = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  background: ${PeopleInAssetsColors.White};
  border: 1px solid ${PeopleInAssetsColors.LightBorder};
  border-radius: 4px;
  z-index: 10;
  margin-top: 4px;
  box-shadow: 0 2px 4px ${PeopleInAssetsColors.BoxShadow};
`;

const DropdownOption = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;

  &:hover {
    background: ${PeopleInAssetsColors.LightGrayBackground};
  }
`;

const InputStyled = styled.input`
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
  padding-right: 20px;
  width: 90%;
`;

// Face thumbnail image
const FaceThumbnailImage = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 4px;
  display: block;
  object-fit: cover;
`;

// Suggestions dropdown (used by PeopleTagEditField)
const SuggestionsDropdownWrapper = styled.div`
  background-color: ${PeopleInAssetsColors.White};
  box-shadow: 1px 2px 6px 0 ${PeopleInAssetsColors.BoxShadow};
  border-radius: 4px;
  position: absolute;
  margin-top: 10px;
  z-index: 2;
  min-width: 200px;
  left: 0;
  width: 120%;
`;

const SuggestionsDropdown = styled.ul`
  list-style: none;
  padding: 4px;
  max-height: 200px;
  overflow-y: auto;
`;

const SuggestionItemButton = styled.button`
  align-items: center;
  background-color: transparent;
  border: none;
  display: flex;
  cursor: pointer;
  padding: 8px;
  text-align: left;
  width: 100%;
  gap: 4px;

  &:hover {
    background-color: ${PeopleInAssetsColors.LightGrayBackground};
    border-radius: 4px;
  }
`;

const SuggestionItemImage = styled.img`
  border-radius: 2px;
  height: 32px;
  width: 32px;
  object-fit: cover;
  flex-shrink: 0;
`;

const SuggestionItemName = styled.span`
  font-size: 14px;
  font-weight: 450;
  color: ${PeopleInAssetsColors.DarkText};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  flex: 1;
`;

const SuggestionItemCount = styled.span`
  color: ${PeopleInAssetsColors.MediumText};
  font-size: 14px;
  font-weight: 400;
  margin-left: 4px;
  flex-shrink: 0;
`;

const AddNameButton = styled.button`
  align-items: center;
  background-color: ${PeopleInAssetsColors.HighlightBackground};
  border: none;
  border-radius: 4px;
  display: flex;
  cursor: pointer;
  padding: 8px;
  text-align: left;
  width: calc(100% - 8px);
  margin: 0 4px 4px;

  &:first-child {
    margin-top: 4px;
  }

  font-size: 14px;
  font-weight: 450;
  line-height: 20px;
  gap: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  .add-label {
    color: ${PeopleInAssetsColors.MutedLabel};
  }

  .add-name {
    color: ${PeopleInAssetsColors.Neutral700};
  }
`;

// Wrapper component that contains everything
const Wrapper = styled.div``;

export {
  PeopleSection,
  SectionHeader,
  HeaderText,
  HeaderIcon,
  PeopleContent,
  PeopleTagsContainer,
  PersonTag,
  PersonImage,
  PersonName,
  PersonNameText,
  RemovePersonButton,
  CustomDropdown,
  DropdownHeader,
  SelectedOption,
  OptionImage,
  OptionText,
  Placeholder,
  DropdownIcon,
  DropdownOptions,
  DropdownOption,
  InputStyled,
  FaceThumbnailImage,
  SuggestionsDropdownWrapper,
  SuggestionsDropdown,
  SuggestionItemButton,
  SuggestionItemImage,
  SuggestionItemName,
  SuggestionItemCount,
  AddNameButton
};

export default Wrapper;
